import { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CheckoutLayout,
  Loading,
  LoadingLayout
} from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';
import { getCart } from 'redux/cart/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const LoadableComponent = lazy(() => retry(() => import('./CheckoutApp')));

const CheckoutAppLoader = () => {
  const dispatch = useDispatch();
  const { t } = useLocalization();
  useEffect(() => {
    dispatch(getCart());
  }, [dispatch]);

  const cartReducer = useSelector((state) => state.cart);

  if (!cartReducer.data) {
    return <LoadingLayout />;
  }

  return (
    <CheckoutLayout title={t('checkout.general.checkout')}>
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </CheckoutLayout>
  );
};

export default CheckoutAppLoader;
